import React, { useEffect, useState } from "react";
import { NavBar, SearchBar } from 'antd-mobile'

import { 
    BodyView,
    ListView
} from "../factory/ViewUtil";
import { CellLastPriceHeaderView, CellLastPriceView, CellStateView } from "../factory/CellViews";

const SearchCoinsController = ({goback, navpush}) => {
    
    const openKline = (data) => {
        navpush('/trend', false, data);
    }

    const [value, setValue] = useState('')
    const [searchedData, setSearchedData] = useState([])
    const [dataSource, setDataSource] = useState([])

    const searchValue = (val) => {
        setValue(val)
        if(val.length === 0) {
            setSearchedData([])
        } else {
            const filteredItems = dataSource.filter((item) => {
                    const symbol = item.symbol
                    if(typeof symbol === 'string') {
                        return item.symbol.toLowerCase().includes(val.toLowerCase())
                    }
                    return false
                }
            );
            setSearchedData(filteredItems)
        }
    };

    useEffect(()=> {
        React.ListenerCandlestickDataSource('SearchCoinsController', (data) => {
            setDataSource(data)
        });
        return () => {
            React.ListenerCandlestickRemove('SearchCoinsController')
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>
                    <SearchBar value={value} onChange={val => {searchValue(val)}} clearable placeholder="Search coin"/>
                </NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    {
                        searchedData.length <=0 ? <CellStateView stateType={4}/> :  <CellLastPriceHeaderView/>
                    }
                    {
                        searchedData.map((item, index) => (
                            <CellLastPriceView
                                item={item}
                                key={index} 
                                onClick={()=>{openKline(item)}}
                                avatar={true}/>
                        ))
                    }
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(SearchCoinsController)